<template>
  <div class="school-body-teacher-index">
    <el-row>
      <el-col :span="24">
        <div class="wrapper-up">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="16">
              <div class="wrapper-up-content">
                <el-row>
                  <el-col :span="24">
                    <div class="section-header">
                      <div class="section-title">
                        <div class="title-icon">
                          <img src="https://wugecdn.steam.fun/resources/static/icon/cof.png" class="function-icon" style="width: 30px; height: 30px;">
                        </div>
                        <span class="title-text">常用功能</span>
                      </div>
                      <div class="section-more" style="visibility: hidden;">
                        <span><i class="el-icon-d-arrow-right"></i></span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                    <div class="content-up">
                      <el-row>
                        <el-col :span="6">
                          <div id="guide1">
                            <el-row class="content-up-imgwrapper">
                              <el-col :span="24">
                                <div class="content-up-img">
                                  <el-image @click="
                                      $router.push({
                                        name: 'prepare-lessons',
                                      })
                                    " src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E8%AF%BE%E8%A1%A8.png" fit="fill"></el-image>
                                </div>
                              </el-col>
                            </el-row>

                            <el-row class="content-up-txt">
                              <el-col :span="24">
                                <div>
                                  <span style="font-size: 14px;color: #323233;">备课中心</span>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>

                        <el-col :span="6" v-if="$store.state.user.userInfo.tchShiziAuth">
                          <div id="guide2">
                            <el-row class="content-up-imgwrapper">
                              <el-col :span="24">
                                <div class="content-up-img">
                                  <el-image @click="
                                      $router.push({
                                        name: 'trainingForTeachers',
                                      })
                                    " src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E6%88%91%E7%9A%84%E4%BD%9C%E5%93%81.png" fit="fill"></el-image>
                                </div>
                              </el-col>
                            </el-row>

                            <el-row class="content-up-txt">
                              <el-col :span="24">
                                <div>
                                  <span style="font-size: 14px;color: #323233;">师资培训</span>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>

                        <el-col :span="6" v-if="$store.state.user.userInfo.tchJiaoyanAuth">
                          <div id="guide3">
                            <el-row class="content-up-imgwrapper">
                              <el-col :span="24">
                                <div class="content-up-img">
                                  <el-image @click="
                                      $router.push({
                                        name: 'teachingAndResearchTraining',
                                      })
                                    " src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E5%AD%A6%E7%94%9F%E4%BD%9C%E5%93%81.png" fit="fill"></el-image>
                                </div>
                              </el-col>
                            </el-row>

                            <el-row class="content-up-txt">
                              <el-col :span="24">
                                <div>
                                  <span style="font-size: 14px;color: #323233;">教研活动</span>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>

                        <el-col :span="6">
                          <div id="guide4">
                            <el-row class="content-up-imgwrapper">
                              <el-col :span="24">
                                <div class="content-up-img">
                                  <el-image @click="dialogVisible = true" src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E8%87%AA%E7%94%B1%E5%88%9B%E4%BD%9C.png" fit="fill"></el-image>
                                </div>
                              </el-col>
                            </el-row>

                            <el-row class="content-up-txt">
                              <el-col :span="24">
                                <div>
                                  <span style="font-size: 14px;color: #323233;">自由创作</span>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="wrapper-up-content" id="guide5" style="padding: 20px; box-sizing: border-box;">
                <div style="width: 100%;height: 100%; background-color:  #F1F7FD;padding: 21px 31px 32px 27px; box-sizing: border-box;position: relative;border-radius: 5px;">
                  <div style="width: 50%;margin-top:6%;">
                    <div style="font-size: 18px;font-weight: 600;line-height: 25px; white-space: nowrap; width: 100%;overflow: hidden;text-overflow: ellipsis;">
                      AI助手-P仔
                    </div>
                    <div style="color: #666666;font-weight: 400;width: 100%;overflow: hidden;">
                      写文案、编代码、做翻译,无所不能
                    </div>
                    <div style="margin-top:15%;">
                      <el-button type="primary" size="mini" @click="ShowChatGPT" :disabled="!$store.state.user.userInfo.tchKftdAuth">立即提问</el-button>
                    </div>
                  </div>
                  <div style="margin-top:5%; height: 80%;position: absolute; top: 0;right: 2%;  ">
                    <img src="https://wugecdn.steam.fun/resources/static/AI_A.png" alt="" style="max-width: 100%;max-height: 100%;width: auto;height: auto;" />
                  </div>
                </div>
                <!-- padding: 21px 31px 32px 27px; -->
                <!-- <div style="background: #F1F7FD;padding: 21px 31px 32px 27px; position: relative;">
                  <div style="font-size: 18px;font-weight: 600;line-height: 25px;">欢迎使用AI助手-p仔</div>
                  <div style="color: #666666;font-weight: 400;">
                    写文案、编代码、做翻译,无所不能
                  </div>
                  <div style="margin-top: 10px;">
                    <el-button type="primary" size="mini">立即提问</el-button>
                  </div>
                  <div style="position: absolute; top: 0;right: 10px;">
                      <img src="https://wugecdn.steam.fun/resources/static/AI_A.png" />
                    </div>
                </div> -->
                <!-- <el-row>
                  <el-col :span="24">
                    <div class="title">今日课程</div>
                  </el-col>
                </el-row> -->

                <!-- <el-row>
                  <el-col :span="24">
                    <div class="content-up">
                      <el-row class="courselist" v-for="(item, index) of todayCourse" :key="index">
                        <el-col :span="24">
                          <div>
                            <el-row type="flex" class="row-bg" justify="space-around">
                              <el-col :span="2">
                                <div>
                                  <el-image v-if="item.class_covers" class="course_cover" :src="item.class_covers"
                                    fit="fill"></el-image>

                                  <el-image v-else class="course_cover" :src="item.img_url" fit="fill"></el-image>
                                </div>
                              </el-col>
                              <el-col :span="12">
                                <div>
                                  <el-row>
                                    <el-col :span="24">
                                      <div class="course_title">
                                        {{ item.lesson_name }}
                                      </div>
                                    </el-col>
                                  </el-row>

                                  <el-row>
                                    <el-col :span="24">
                                      <div>
                                        <el-row>
                                          <el-col :span="24">
                                            <div class="course_time">
                                              {{
        item.start_class_date
          .trim()
          .split(" ")[1]
      }}
                                              -
                                              {{
          item.end_class_date
            .trim()
            .split(" ")[1]
        }}
                                            </div>
                                          </el-col>
                                        </el-row>
                                      </div>
                                    </el-col>
                                  </el-row>

                                  <el-row>
                                    <el-col :span="24">
                                      <div class="course_class">
                                        {{ item.className }}
                                      </div>
                                    </el-col>
                                  </el-row>
                                </div>
                              </el-col>
                              <el-col :span="4">
                                <div class="go_teach">
                                  <el-button type="primary" size="mini" round @click="goTeachlessons(item)">上课
                                  </el-button>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row> -->
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="wrapper-down">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="withCol">
              <div class="wrapper-down-content" id="guide7">
                <el-row>
                  <el-col :span="24">
                    <div class="section-header">
                      <div class="section-title">
                        <div class="title-icon">
                          <img src="https://wugecdn.steam.fun/resources/static/icon/my.png" class="class-icon" style="width: 30px; height: 30px;">
                        </div>
                        <span class="title-text">我的班级</span>
                      </div>
                      <div class="section-more">
                        <span @click="$router.push({ name: 'myClass' })">更多 <i class="el-icon-d-arrow-right"></i></span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                    <div class="content-up boxStyle">
                      <el-row>
                        <el-col :span="24">
                          <div style="overflow: hidden;">
                            <el-row>
                              <el-col class="class_img1" :span="6" :xs="12" :sm="8" :md="6" :lg="6" :xl="4" v-for="(item, index) in classList" :key="index">
                                <div class="myclass" @click="
                                    handleClassClick(item.id, item.start_date)
                                  ">
                                  <div class="class_img" ref="myElement">
                                    <canvas :ref="'canvas' + index" :width="widthStyle" :height="heightStyle"></canvas>
                                  </div>

                                  <div class="class_room">
                                    <el-row>
                                      <el-col :span="24">
                                        <div class="classname">
                                          <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                            <span>{{ item.name }}</span>
                                          </el-tooltip>
                                        </div>
                                      </el-col>
                                    </el-row>
                                  </div>

                                  <div class="class_time">
                                    <span class="lesson-count">
                                      <i class="el-icon-notebook-2"></i>
                                      <span style="font-weight: bold; color: #909399;">共</span>
                                      {{ item.tchPlanNum }}
                                      <span style="font-weight: bold; color: #909399;">节</span>
                                    </span>
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                        <!-- <el-col :span="4">
                          <div class="myclass_goall">
                            <el-link :underline="false" type="primary" @click="
        $router.push({
          name: 'myClass',
        })
        ">查看全部>></el-link>
                          </div>
                        </el-col> -->
                      </el-row>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="calendar-card" id="guide8">
                <div class="section-header-calendar">
                  <div class="section-title">
                    <div class="title-icon">
                      <img src="https://wugecdn.steam.fun/resources/static/icon/cc.png" class="calendar-icon" style="width: 30px; height: 30px;">
                    </div>
                    <span class="title-text">课程日历</span>
                    <el-tag size="mini" class="month-tag">{{ current_month }} 月</el-tag>
                  </div>
                  <div class="section-more">
                    <span @click="goNext">更多 <i class="el-icon-d-arrow-right"></i></span>
                  </div>
                </div>
                <div class="calendar-nav">
                  <div class="nav-arrow nav-prev" @click="lefttNext">
                    <i class="el-icon-arrow-left"></i>
                  </div>
                  <div class="calendar-days">
                    <div class="weekday-row">
                      <div v-for="(item, index) in weekDayList" :key="'weekday-'+index" class="weekday-item">
                        {{ item }}
                      </div>
                    </div>
                    <div class="date-row">
                      <div v-for="(item, index) in weekDays" :key="'date-'+index" class="date-item-wrapper">
                        <div class="date-item" 
                             :class="{ 'date-active': activeIndex == item.slice(-2) }" 
                             @click="changeBtn(item)">
                          {{ item.slice(-2) }}
                          <div v-if="hasCourse(item)" class="date-dot"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="nav-arrow nav-next" @click="rightNext">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="calendar-content">
                  <el-empty v-if="activities.length == 0" :image-size="120" description="暂无课程">
                    <img slot="image" src="https://wugecdn.steam.fun/resources/static/icon/empty-calendar.png" class="empty-image" />
                  </el-empty>

                  <el-timeline>
                    <el-timeline-item :color="item.color" v-for="(item, index) in activities" :key="index" placement="top">
                      <div class="timeline-card">
                        <div class="timeline-header">
                          <div class="timeline-time">
                            <i class="el-icon-time"></i>
                            <span>{{ item.hour }} </span>
                            <span v-if="item.start_class_date">
                              {{ item.start_class_date.substring(11, 16) }} -
                              {{ item.end_class_date.substring(11, 16) }}</span>
                          </div>
                          <div class="timeline-action">
                            <span v-if="item.sign_date">
                              <el-tag size="small" type="info" class="action-tag signed" @click="goTeachlessons(item)">已签到</el-tag>
                            </span>
                            <span v-else>
                              <el-tag size="small" class="action-tag" @click="goTeachlessons(item)">去上课</el-tag>
                            </span>
                          </div>
                        </div>
                        <div class="timeline-content">
                          <div class="timeline-title">
                        
                              <span class="lesson-title">{{ item.lessionTitle }}</span>
          
                          </div>
                          <div class="timeline-class">
                            <i class="el-icon-school"></i> {{ item.className }}
                          </div>
                        </div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                </div>
                <div class="calendar-footer" v-if="activities.length != 0">
                  <el-pagination small @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size" layout="prev, pager, next,total" :total="total"></el-pagination>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="编程工具" :visible.sync="dialogVisible" width="65%" append-to-body>
      <el-row style="text-align: center">
        <el-col :span="6">
          <div class="tools">
            <div>
              <el-image style="width: 150px; height: 150px; border-radius: 5px" src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E5%88%9B%E4%BD%9C%E9%80%89%E6%8B%A9-01.png" fit="fill"></el-image>
            </div>
            <div style="margin-top: -20px; font-size: 16px; font-weight: bold">
              <svg style="position: relative; top: 4px" v-if="!jr_show" t="1666275059447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2880" width="18" height="18">
                <path d="M752 419.2h-64V304.1C688 207 609 128 512 128s-176 79-176 176.1v115.1h-64V304.1c0-64.1 25-124.4 70.3-169.8C387.6 89 447.9 64 512 64s124.4 25 169.7 70.3C727 179.7 752 240 752 304.1v115.1z" fill="#727272" p-id="2881"></path>
                <path d="M864 507.7v360.2c0 50.8-40.5 92.1-90.2 92.1H250.2c-49.7 0-90.2-41.3-90.2-92.1V507.7c0-50.8 40.5-92.1 90.2-92.1h523.6c49.7 0.1 90.2 41.4 90.2 92.1z" fill="#E6C27C" p-id="2882"></path>
              </svg>
              Jrcode
            </div>
            <div style="margin-top: 0px; color: #909399">
              编程启蒙<span style="cursor: pointer" @click="ClearChrome">入门</span>的首选
            </div>
            <div>
              <el-button :disabled="!jr_show" @click="chooseTools('jrcode')" style="margin-top: 21px" type="success" size="small">Let's code</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tools">
            <div>
              <el-image style="width: 150px; height: 150px; border-radius: 5px" src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E5%88%9B%E4%BD%9C%E9%80%89%E6%8B%A9-02.png" fit="fill"></el-image>
            </div>
            <div style="margin-top: -20px; font-size: 16px; font-weight: bold">
              <svg style="position: relative; top: 4px" v-if="!sc_show" t="1666275059447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2880" width="18" height="18">
                <path d="M752 419.2h-64V304.1C688 207 609 128 512 128s-176 79-176 176.1v115.1h-64V304.1c0-64.1 25-124.4 70.3-169.8C387.6 89 447.9 64 512 64s124.4 25 169.7 70.3C727 179.7 752 240 752 304.1v115.1z" fill="#727272" p-id="2881"></path>
                <path d="M864 507.7v360.2c0 50.8-40.5 92.1-90.2 92.1H250.2c-49.7 0-90.2-41.3-90.2-92.1V507.7c0-50.8 40.5-92.1 90.2-92.1h523.6c49.7 0.1 90.2 41.4 90.2 92.1z" fill="#E6C27C" p-id="2882"></path>
              </svg>
              Scratch
            </div>
            <div style="margin-top: 0px; color: #909399">
              最火爆的图形化语言
            </div>
            <div>
              <el-button :disabled="!sc_show" @click="chooseTools('scratch')" style="margin-top: 21px" type="warning" size="small">Let's code</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tools">
            <div>
              <el-image style="width: 150px; height: 150px; border-radius: 5px" src="https://scratchshop.oss-cn-shanghai.aliyuncs.com/courses/%E5%88%9B%E4%BD%9C%E9%80%89%E6%8B%A9-12.png" fit="fill"></el-image>
            </div>
            <div style="margin-top: -20px; font-size: 16px; font-weight: bold">
              <svg style="position: relative; top: 4px" v-if="!python_show" t="1666275059447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2880" width="18" height="18">
                <path d="M752 419.2h-64V304.1C688 207 609 128 512 128s-176 79-176 176.1v115.1h-64V304.1c0-64.1 25-124.4 70.3-169.8C387.6 89 447.9 64 512 64s124.4 25 169.7 70.3C727 179.7 752 240 752 304.1v115.1z" fill="#727272" p-id="2881"></path>
                <path d="M864 507.7v360.2c0 50.8-40.5 92.1-90.2 92.1H250.2c-49.7 0-90.2-41.3-90.2-92.1V507.7c0-50.8 40.5-92.1 90.2-92.1h523.6c49.7 0.1 90.2 41.4 90.2 92.1z" fill="#E6C27C" p-id="2882"></path>
              </svg>
              Python
            </div>
            <div style="margin-top: 0px; color: #909399">
              源代码编程进阶挑战
              <span style="cursor: pointer" @click="Update">
                <svg t="1658209599264" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8284" width="20" height="20">
                  <path d="M512 56.888889a455.111111 455.111111 0 1 1 0 910.222222A455.111111 455.111111 0 0 1 512 56.888889zM417.507556 332.344889H285.809778L439.751111 739.555556h136.419556l151.096889-407.210667h-127.772445L509.155556 625.379556 417.564444 332.344889z" p-id="8285" fill="#1296db"></path>
                </svg>
              </span>
            </div>
            <div>
              <el-button :disabled="!python_show" @click="chooseTools('python')" style="margin-top: 18px; background: #807be0; color: white" size="small">Let's code</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tools">
            <div>
              <el-image style="width: 150px; height: 150px; border-radius: 5px" src="https://wugecdn.steam.fun/resources/static/images/C_logo.png" fit="fill"></el-image>
            </div>
            <div style="margin-top: -20px; font-size: 16px; font-weight: bold">
              <svg style="position: relative; top: 4px" v-if="!cplus_show" t="1666275059447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2880" width="18" height="18">
                <path d="M752 419.2h-64V304.1C688 207 609 128 512 128s-176 79-176 176.1v115.1h-64V304.1c0-64.1 25-124.4 70.3-169.8C387.6 89 447.9 64 512 64s124.4 25 169.7 70.3C727 179.7 752 240 752 304.1v115.1z" fill="#727272" p-id="2881"></path>
                <path d="M864 507.7v360.2c0 50.8-40.5 92.1-90.2 92.1H250.2c-49.7 0-90.2-41.3-90.2-92.1V507.7c0-50.8 40.5-92.1 90.2-92.1h523.6c49.7 0.1 90.2 41.4 90.2 92.1z" fill="#E6C27C" p-id="2882"></path>
              </svg>

              C/C++
            </div>
            <div style="margin-top: 0px; color: #909399">
              信息学奥赛必备语言
            </div>
            <div>
              <el-button :disabled="!cplus_show" @click="chooseTools('cpp')" style="margin-top: 22px; background: #0280ce; color: white" size="small">Let's code</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!--ChatGPT-->
    <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" size="50%">
      <div style="overflow-y: scroll;">
        <div style="text-align: center;margin-top:20px;color:#5e8ff8;font-size: 24px;font-weight: bold;">
          与Ai对话
        </div>
        <div style="text-align: center;margin-top:0px;color:#c7c8ca;font-size: 14px;font-weight: bold;">
          输入你想问的问题
        </div>

        <div style="padding:20px;">
          <el-input type="textarea" :rows="8" maxlength="5000" show-word-limit placeholder="你有什么问题，我都可以回答你哦！" v-model="request_info">
          </el-input>
        </div>

        <div style="text-align:center;">
          <el-button size="small" type="primary" @click="generate_ai" :loading="loading">立即提问</el-button>

          <el-button size="small" @click="ResetAi">重置<i class="el-icon-delete el-icon--right"></i></el-button>
        </div>

        <div style="text-align: center;margin-top: 20px;border:1px solid #d9dde5;margin: 20px;border-radius: 10px;padding-bottom:20px;">
          <div v-if="!streamCache">
            <el-image style="width:20%;" class="contant_img_2" src="https://wugecdn.steam.fun/resources/static/AI_A.png" fit="fill"></el-image>
          </div>

          <div v-if="!streamCache" style="font-size: 18px;font-weight: bold;">
            等待您的输入
          </div>
          <div v-if="!streamCache">点击提问按钮开始吧</div>

          <mavon-editor v-if="streamCache" :style="{ 'min-height': '0px', 'margin-top': '20px' }" preview-background="#fff" v-model="ai_text" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import moment from "moment";
import { tchGetTchSubjectAuth } from "@/api/classroom/teacher_api";
// getTchIndexClassList,
//getTchTodayCourse
import {
  updateTchPlanSignState,
  getGhatGptToken,
  getTchIndexClassListWithTchPlanInfo,
  tchGetTeachingPlanList,
} from "@/api/educational.js";

// 在Vue组件中引入markdown-it
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import "highlight.js/styles/base16/monokai.css";
import cpp from "highlight.js/lib/languages/cpp";
hljs.registerLanguage("cpp", cpp);

// 使用markdown-it
let md = new MarkdownIt({
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return (
          '<pre class="hljs"><code>' +
          hljs.highlight(lang, str, true).value +
          "</code></pre>"
        );
      } catch (error) {
        console.log(error);
      }
    }
    return (
      '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + "</code></pre>"
    );
  },
});

export default {
  name: "classroomIndex",
  props: {
    classData: Object,
  },
  watch: {
    classData() {
      console.log("子组件收到的今日课程");
      console.log(this.classData);
    },
  },

  data() {
    return {
      timeNow: "",
      page_no: 1,
      page_size: 3,
      total: 1,
      activities: [],
      activeIndex: 0,
      weekDayList: ["一", "二", "三", "四", "五", "六", "日"],
      weekDays: [],
      widthStyle: null,
      heightStyle: null,
      classList: [],
      todayCourse: [],
      withCol: 16,
      todayCourses: [],
      dialogVisible: false,
      jr_show: false,
      sc_show: false,
      python_show: false,
      cplus_show: false,
      subjectList: [], //老师科目权限
      courseDays: {}, // 存储有课程的日期信息

      api_key: "",
      //Chatgpt
      drawer: false,

      //Ai服务器
      streamCache: "",
      loading: false,
      request_info: "",
      ai_text: "",

      current_month: "",
    };
  },

  mounted() {
    console.log("走生命周期了吗");
    this.freshData();
    this.tchGetTchSubjectAuth();
    this.getTchIndexClassList();
    
    // 设置当前日期
    this.timeNow = moment().format("YYYY-MM-DD");
    this.current_month = this.timeNow.slice(5, 7);
    this.activeIndex = this.timeNow.slice(-2);
    
    // 获取当前周的日期列表
    this.weekDays = this.getCurrentWeekDates(this.timeNow);
    
    // 获取课程数据
    this.tchGetTeachingPlanList();
    this.getWeekCourses();
  },

  methods: {
    // 获取指定日期所在周的日期列表
    getCurrentWeekDates(date) {
      // 获取周一日期
      const weekStart = moment(date, "YYYY-MM-DD").startOf("isoWeek");
      const weekDates = [];
      
      // 生成周一到周日的日期列表
      for (let i = 0; i < 7; i++) {
        const day = moment(weekStart).add(i, "days");
        weekDates.push(day.format("YYYY-MM-DD"));
      }
      
      return weekDates;
    },

    compareTime(Date) {
      const currentTime = moment(); // 获取当前时间
      const inputTime = moment(Date); // 传入的时间

      const isBefore = inputTime.isBefore(currentTime); // 比较时间是否早于当前时间

      console.log("传入的时间是否比当前时间早：", isBefore);
    },

    tchGetTeachingPlanList() {
      tchGetTeachingPlanList({
        page_no: this.page_no,
        page_size: this.page_size,
        start_date: this.timeNow + " 00:00:00",
        end_date: this.timeNow + " 23:59:59",
      }).then((res) => {
        this.activities = res.teachingPlan;
        res.teachingPlan.map((item) => {
          if (item.sign_date) {
            item.color = "";
          } else {
            item.color = "#1078FF";
          }
          if (
            moment(item.start_class_date, "YYYY-MM-DD HH:mm:ss").hour() >= 12
          ) {
            item.hour = "下午";
          } else {
            item.hour = "上午";
          }
        });
        // const startClassDate = "2024-04-10 17:30:00";
        // const startClassMoment = moment(startClassDate, "YYYY-MM-DD HH:mm:ss");
        // const hour = startClassMoment.hour();
        // if (hour >= 12) {
        //   console.log("下午");
        // } else {
        //   console.log("上午");
        // }
        this.total = res.total;
        console.log(res, 789456416);
      });
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.tchGetTeachingPlanList();
    },
    goNext() {
      this.$router.push({
        name: "classroomDetails",
      });
    },
    lefttNext() {
      this.page_no = 1;
      
      // 保存当前选中日期是周几
      const currentDayOfWeek = moment(this.timeNow, "YYYY-MM-DD").day();
      
      // 计算上一周的日期（以周一为开始日）
      const previousWeekStart = moment(this.weekDays[0], "YYYY-MM-DD")
        .subtract(7, "days")
        .format("YYYY-MM-DD");
        
      // 更新周列表
      this.weekDays = this.getCurrentWeekDates(previousWeekStart);
      
      // 选中与当前日期同一天的日期
      this.timeNow = this.weekDays[currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1]; // 调整周日的情况
      this.activeIndex = this.timeNow.slice(-2);
      
      // 更新月份显示
      this.current_month = this.timeNow.slice(5, 7);
      
      // 获取新的课程数据
      this.tchGetTeachingPlanList();
      this.getWeekCourses();
    },
    
    rightNext() {
      this.page_no = 1;
      
      // 保存当前选中日期是周几
      const currentDayOfWeek = moment(this.timeNow, "YYYY-MM-DD").day();
      
      // 计算下一周的日期（以周一为开始日）
      const nextWeekStart = moment(this.weekDays[0], "YYYY-MM-DD")
        .add(7, "days")
        .format("YYYY-MM-DD");
        
      // 更新周列表
      this.weekDays = this.getCurrentWeekDates(nextWeekStart);
      
      // 选中与当前日期同一天的日期
      this.timeNow = this.weekDays[currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1]; // 调整周日的情况
      this.activeIndex = this.timeNow.slice(-2);
      
      // 更新月份显示
      this.current_month = this.timeNow.slice(5, 7);
      
      // 获取新的课程数据
      this.tchGetTeachingPlanList();
      this.getWeekCourses();
    },

    changeBtn(row) {
      console.log("直接选择日期");
      this.timeNow = row;
      this.page_no = 1;
      this.activeIndex = row.slice(-2);
      
      // 获取选中日期的数据
      this.tchGetTeachingPlanList();
    },

    ResetAi() {
      this.request_info = "";
      this.streamCache = "";
    },

    //动态获得GPT-TOKEN
    getGhatGptToken() {
      getGhatGptToken().then((res) => {
        console.log("动态获取GPT");
        console.log(res.chatGptKeyList);
        localStorage.setItem("gpt_token", res.chatGptKeyList[0].key);
      });
    },

    //Ai调用函数
    async generate_ai() {
      console.log("新的Ai服务器");

      this.streamCache = "";
      this.loading = true;

      fetch("https://ai.wugedianxia.cn/api/chat/completions", {
        method: "POST",
        body: JSON.stringify({
          text: this.request_info,
          //sessionId: 894,
          appId: 60,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("gpt_token"),
        },
      }).then((res) => {
        console.log("新人工智能服务器返回");
        console.log(res);

        const reader = res.body.getReader();
        const decoder = new TextDecoder("utf-8");

        let that = this;
        reader.read().then(async function processText(res) {
          //console.log("循环读取信息");
          //console.log(res);

          if (res.done || !that.loading) {
            return;
          }

          const decodeContent = decoder.decode(res.value);

          //console.log("decodeContent");
          //console.log(decodeContent);

          // error
          if (decodeContent.includes(`"error": {\n`)) {
            console.log("账户错误");
            console.log(decodeContent);
            that.loading = false;
            return;
          }

          // done
          if (decodeContent.includes("data: [DONE]")) {
            that.loading = false;
            console.log("回答完成");
            return;
          }

          decodeContent
            .replaceAll("data: ", "")
            .split("\n")
            .filter(Boolean)
            .forEach(async (item) => {
              const itemObj = JSON.parse(item);

              console.log("新服务器回答");
              console.log(itemObj);

              if (!itemObj.data) {
                return;
              }

              const str = itemObj.data;

              if (itemObj.type == 'string') {
                that.streamCache += str
                that.ai_text = md.render(that.streamCache);
              }

            });

          return reader.read().then(processText);
        });
      });
    },

    getTchIndexClassList() {
      getTchIndexClassListWithTchPlanInfo({
        pageLimit: 20,
      }).then((res) => {
        res.classlist.map((item) => {
          if (item.teachingPlanLessonImgUrl.length == 0) {
            item.teachingPlanLessonImgUrl.push(
              "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/static/060798de-c2de-4b7a-9952-3175982472bc/21020-体验.png"
            );
            // item.img_url = 'https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/static/060798de-c2de-4b7a-9952-3175982472bc/21020-体验.png'
          }
        });
        console.log(res, 456456);
        this.classList = res.classlist;
        console.log(this.classList, 456456);
        this.$nextTick(() => {
          const element1 = this.$refs.myElement;
          this.widthStyle = element1[0].offsetWidth;
          this.heightStyle = element1[0].offsetHeight;
          console.log(element1[0].offsetWidth, 78946545646);
          console.log(element1[0].offsetHeight, 78946545646);
          const images = [];
          for (let i = 0; i < this.classList.length; i++) {
            console.log(this.classList[i].tchPlanNum, 789789546456);
            const canvas = this.$refs["canvas" + i][0];
            const ctx = canvas.getContext("2d");
            images.push(this.classList[i].teachingPlanLessonImgUrl);

            // 清空画布
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // 设置圆角
            this.roundRectangle(ctx, 0, 0, canvas.width, canvas.height, 10);
            ctx.clip();

            if (this.classList[i].tchPlanNum >= 4) {
              // 主图 + 缩略图模式
              const mainImageLoaded = (img) => {
                // 首先绘制第一张作为主图
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
                
                // 添加半透明渐变遮罩
                const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
                gradient.addColorStop(0, 'rgba(0, 0, 0, 0.1)');
                gradient.addColorStop(1, 'rgba(0, 0, 0, 0.3)');
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                
                // 在右上角绘制三张小缩略图
                const thumbnailSize = Math.min(canvas.width, canvas.height) * 0.2;
                const thumbnailMargin = 5;
                const thumbnailBgColor = 'rgba(255, 255, 255, 0.8)';
                
                // 仅处理额外的三张图片
                for (let j = 1; j < 4 && j < images[i].length; j++) {
                  const thumbnailImg = new Image();
                  thumbnailImg.onload = () => {
                    const x = canvas.width - thumbnailSize - thumbnailMargin;
                    const y = thumbnailMargin + (j-1) * (thumbnailSize + thumbnailMargin);
                    
                    // 绘制缩略图背景
                    ctx.save();
                    this.roundRectangle(ctx, x, y, thumbnailSize, thumbnailSize, 5);
                    ctx.fillStyle = thumbnailBgColor;
                    ctx.fill();
                    
                    // 绘制缩略图图片
                    this.roundRectangle(ctx, x + 2, y + 2, thumbnailSize - 4, thumbnailSize - 4, 3);
                    ctx.clip();
                    ctx.drawImage(
                      thumbnailImg, 
                      0, 0, 
                      thumbnailImg.width, thumbnailImg.height, 
                      x + 2, y + 2, 
                      thumbnailSize - 4, thumbnailSize - 4
                    );
                    ctx.restore();
                  };
                  thumbnailImg.src = images[i][j];
                }
              };
              
              if (images[i].length > 0) {
                const mainImg = new Image();
                mainImg.onload = () => mainImageLoaded(mainImg);
                mainImg.src = images[i][0];
              }
            } else if (
              this.classList[i].tchPlanNum == 2 ||
              this.classList[i].tchPlanNum == 3
            ) {
              // 美化的拼接布局
              if (images[i].length === 2) {
                // 左右拼接
                const gap = 4;
                const leftWidth = canvas.width * 0.55;
                const rightWidth = canvas.width - leftWidth - gap;
                
                // 左图
                const img1 = new Image();
                img1.onload = () => {
                  ctx.save();
                  this.roundRectangle(ctx, 0, 0, leftWidth, canvas.height, 8);
                  ctx.clip();
                  ctx.drawImage(img1, 0, 0, img1.width, img1.height, 0, 0, leftWidth, canvas.height);
                  ctx.restore();
                };
                img1.src = images[i][0];
                
                // 右图
                const img2 = new Image();
                img2.onload = () => {
                  ctx.save();
                  this.roundRectangle(ctx, leftWidth + gap, 0, rightWidth, canvas.height, 8);
                  ctx.clip();
                  ctx.drawImage(img2, 0, 0, img2.width, img2.height, leftWidth + gap, 0, rightWidth, canvas.height);
                  ctx.restore();
                };
                img2.src = images[i][1];
                
              } else if (images[i].length >= 3) {
                // 主图 + 两个小图
                const gap = 4;
                const mainHeight = canvas.height * 0.6;
                const smallHeight = (canvas.height - mainHeight - gap) / 2;
                
                // 上方主图
                const mainImg = new Image();
                mainImg.onload = () => {
                  ctx.save();
                  this.roundRectangle(ctx, 0, 0, canvas.width, mainHeight, 8);
                  ctx.clip();
                  ctx.drawImage(mainImg, 0, 0, mainImg.width, mainImg.height, 0, 0, canvas.width, mainHeight);
                  ctx.restore();
                };
                mainImg.src = images[i][0];
                
                // 左下小图
                const smallImg1 = new Image();
                smallImg1.onload = () => {
                  ctx.save();
                  this.roundRectangle(ctx, 0, mainHeight + gap, canvas.width/2 - gap/2, smallHeight, 8);
                  ctx.clip();
                  ctx.drawImage(smallImg1, 0, 0, smallImg1.width, smallImg1.height, 0, mainHeight + gap, canvas.width/2 - gap/2, smallHeight);
                  ctx.restore();
                };
                smallImg1.src = images[i][1];
                
                // 右下小图
                const smallImg2 = new Image();
                smallImg2.onload = () => {
                  ctx.save();
                  this.roundRectangle(ctx, canvas.width/2 + gap/2, mainHeight + gap, canvas.width/2 - gap/2, smallHeight, 8);
                  ctx.clip();
                  ctx.drawImage(smallImg2, 0, 0, smallImg2.width, smallImg2.height, canvas.width/2 + gap/2, mainHeight + gap, canvas.width/2 - gap/2, smallHeight);
                  ctx.restore();
                };
                smallImg2.src = images[i][2];
              }
              
            } else if (
              this.classList[i].tchPlanNum == 1 ||
              this.classList[i].tchPlanNum == 0
            ) {
              // 单图模式加上精美效果
              const drawSingleImage = (img) => {
                // 绘制主图
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
                
                // 添加渐变遮罩
                const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
                gradient.addColorStop(0, 'rgba(0, 0, 0, 0.05)');
                gradient.addColorStop(0.7, 'rgba(0, 0, 0, 0.1)');
                gradient.addColorStop(1, 'rgba(0, 0, 0, 0.3)');
                ctx.fillStyle = gradient;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                
                if (this.classList[i].tchPlanNum === 0) {
                  // 如果是没有课程的班级，添加特殊标记
                  ctx.save();
                  ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                  
                  ctx.fillStyle = 'white';
                  ctx.font = 'bold 16px Arial';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  ctx.fillText('待排课', canvas.width/2, canvas.height/2);
                  ctx.restore();
                }
              };
              
              if (images[i].length > 0) {
                const img = new Image();
                img.onload = () => drawSingleImage(img);
                img.src = images[i][0];
              }
            }
          }
        });
      });
    },
    
    // 绘制圆角矩形的辅助函数
    roundRectangle(ctx, x, y, width, height, radius) {
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.arcTo(x + width, y, x + width, y + radius, radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
      ctx.lineTo(x + radius, y + height);
      ctx.arcTo(x, y + height, x, y + height - radius, radius);
      ctx.lineTo(x, y + radius);
      ctx.arcTo(x, y, x + radius, y, radius);
      ctx.closePath();
    },

    // getTchTodayCourse() {
    //   getTchTodayCourse().then((res) => {
    //     console.log(res, 7845864564);
    //     this.todayCourse = res.todayCourse
    //   })
    // },
    Update() {
      console.log("检测python当前版本");

      if (localStorage.getItem("current_py_version") == "v2") {
        this.$confirm(
          "是否切换至v1版本编辑器,配合老版本客户端或者网页小助手使用！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.$message.success("已切换至v1版本编辑器！");
          localStorage.setItem("current_py_version", "v1");
        });
      } else if (localStorage.getItem("current_py_version") == "v1") {
        this.$confirm(
          "是否切换至v2版本编辑器,配合新版本客户端或者网页小助手使用！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.$message.success("已切换至v2版本编辑器！");
          localStorage.setItem("current_py_version", "v2");
        });
      } else {
        this.$confirm(
          "是否切换至v1版本编辑器,配合新版本客户端或者网页小助手使用！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.$message.success("已切换至v1版本编辑器！");
          localStorage.setItem("current_py_version", "v1");
        });
      }
    },

    ClearChrome() {
      window.open("/jrcode/home.html", "_bank");
    },

    //刷新账号信息
    freshData() {
      this.$store.dispatch("freshUserData");
    },

    //获取老师科目权限列表
    tchGetTchSubjectAuth() {
      console.log("查询老师科目权限");
      tchGetTchSubjectAuth().then((res) => {
        this.subjectList = res.subjectList;
        console.log("获取老师权限列表");
        console.log(res);

        if (res.subjectList.length == 0) {
          this.$message.warning("无科目权限");
          return;
        }
        for (let k = 0; k < res.subjectList.length; k++) {
          if (res.subjectList[k].code == "1") {
            this.jr_show = true;
          } else if (res.subjectList[k].code == "2") {
            this.sc_show = true;
          } else if (res.subjectList[k].code == "3") {
            this.python_show = true;
          } else if (res.subjectList[k].code == "4") {
            this.cplus_show = true;
          }
        }
      });
    },

    handleClassClick(id) {
      console.log("班级ID");
      console.log(id);
      this.$router.push({
        name: "classlistDescTeacher",
        query: {
          class_id: id,
        },
      });
    },

    //去上课
    goTeachlessons(item) {
      console.log("去上课");
      console.log(item, 7841789);

      sessionStorage.setItem("subject_id", item.subject_id);
      sessionStorage.setItem("Classroom", JSON.stringify(item));

      this.$router.push({
        name: "teachLessons",
        query: {
          curriculumMaterial_id: item.curriculum_meterial_id,
          backname: "classroomIndex",
          classid: item.curriculum_class_id,
          teaching_plan_id: item.id,
          eduCampusId: item.educational_institution_campus_id,
        },
      });
    },

    //更新教学计划的签到状态
    updateTchPlanSignState(item) {
      updateTchPlanSignState({
        teaching_plan_id: item.id,
      }).then((res) => {
        console.log("更新教学计划的签到状态");
        console.log(res);
        if (res.is_update) {
          // this.$message.success("课程已解锁,可以开始上课啦!");
          this.$router.push({
            name: "teachLessons",
            query: {
              curriculumMaterial_id: item.curriculum_meterial_id,
              backname: "classlistIndexTeacher",
              classid: item.curriculum_class_id,
              teaching_plan_id: item.id,
              eduCampusId: item.educational_institution_campus_id,
            },
          });
        }
      });
    },

    //自由创作工具
    chooseTools(cmd) {
      console.log(cmd);
      if (cmd == "jrcode") {
        window.location.href =
          "/jrcode/create.html?mode=edit&filepath=https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/jrcode/project.sjr";
      } else if (cmd == "scratch") {
        window.location.href = "/scratch/index.html";
      } else if (cmd == "python") {
        if (localStorage.getItem("current_py_version") == "v2") {
          this.$router.push({
            name: "python_editor_v2",
          });
        } else if (localStorage.getItem("current_py_version") == "v1") {
          this.$router.push({
            name: "python_editor",
          });
        } else {
          this.$router.push({
            name: "python_editor_v2",
          });

          localStorage.setItem("current_py_version", "v2");
        }

        this.dialogVisible = false;
      } else if (cmd === "cpp") {
        window.location.href = "/cpp/editor";
      }
    },

    ShowChatGPT() {
      this.getGhatGptToken();
      this.drawer = true;
    },

    GoComment() {
      console.log("前往评论");
      this.$router.push({
        name: "works",
      });
    },
    GoClasses() {
      console.log("前往班级");
      this.$router.push({
        name: "myClass",
      });
    },
    hasCourse(date) {
      return this.courseDays[date] && this.courseDays[date].length > 0;
    },
    
    // 获取整周的课程信息
    getWeekCourses() {
      // 构建整周的开始和结束日期
      const weekStart = this.weekDays[0] + " 00:00:00";
      const weekEnd = this.weekDays[this.weekDays.length - 1] + " 23:59:59";
      
      // 使用API获取整周的课程信息
      tchGetTeachingPlanList({
        page_no: 1,
        page_size: 100, // 设置一个较大的值，确保获取到所有课程
        start_date: weekStart,
        end_date: weekEnd,
      }).then((res) => {
        // 将结果整理到courseDays对象中，以日期为键
        this.courseDays = {};
        if (res.teachingPlan && res.teachingPlan.length > 0) {
          res.teachingPlan.forEach(item => {
            if (item.start_class_date) {
              const day = item.start_class_date.substring(0, 10);
              if (!this.courseDays[day]) {
                this.courseDays[day] = [];
              }
              this.courseDays[day].push(item);
            }
          });
        }
        console.log("整周课程信息：", this.courseDays);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.txtColor {
  color: #323233;
}

.bgBorder {
  background: #439fff;
  color: #fff;
  border-radius: 4px;
}

.school-body-teacher-index {
  height: calc(100vh - 75px);
  background: #f1f7fe;
  margin: 5px;

  .wrapper-up {
    .wrapper-up-content {
      background: white;
      // height: calc((100vh - 231px) / 2 - 20px);
      height: calc((100vh - 60px) / 3 - 20px);

      margin: 5px;
      border-radius: 5px;

      .function-title {
        padding: 12px 20px;
        font-size: 16px;
        font-weight: bold;
        color: #0280ce;
        display: flex;
        align-items: center;
        
        i {
          color: #ffcc00;
          font-size: 18px;
          margin-right: 6px;
          position: relative;
          
          &:before {
            content: "";
            position: absolute;
            width: 24px;
            height: 24px;
            background: rgba(255, 204, 0, 0.15);
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: -1;
          }
        }
      }

      .title {
        height: 50px;

        line-height: 50px;
        font-size: 20px;
        padding-left: 20px;
      }

      .title1 {
        color: #323233;
        font-weight: 600;
        height: 28px;
        line-height: 28px;
        padding-left: 30px;
        padding-top: 30px;
        font-size: 16px;
      }

      .content-up {
        // height: calc((100vh - 370px) / 2 - 70px);
        // height: calc((100vh - 60px) / 3 - 20px);
        height: calc((100vh - 60px) / 3 - 81px);

        // overflow-y: auto;

        .content-up-imgwrapper {
          margin-top: 5%;
          padding: 8px;
          text-align: center;
          cursor: pointer;

          .content-up-img {
            width: 80px;
            height: 80px;
            border-radius: 16px;
            margin: 0 auto;
            overflow: hidden;
            position: relative;
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            background: #f8faff;
            display: flex;
            align-items: center;
            justify-content: center;
            
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(145deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%);
              z-index: 1;
              border-radius: 16px;
            }
            
            .el-image {
              width: 85%;
              height: 85%;
              z-index: 2;
              transition: all 0.3s ease;
            }
            
            &:hover {
              transform: translateY(-5px) scale(1.05);
              box-shadow: 0 12px 20px rgba(64, 158, 255, 0.15);
              
              .el-image {
                transform: scale(1.1);
              }
            }
          }
        }

        .content-up-txt {
          width: 100%;
          line-height: 20px;
          text-align: center;
          margin-top: 10px;
          
          div span {
            font-size: 15px;
            color: #323233;
            font-weight: 500;
            position: relative;
            display: inline-block;
            
            &:after {
              content: '';
              position: absolute;
              bottom: -2px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 2px;
              background: #409EFF;
              transition: all 0.3s ease;
              border-radius: 5px;
            }
          }
        }
        
        #guide1, #guide2, #guide3, #guide4 {
          transition: all 0.3s ease;
          padding: 5px;
          
          &:hover {
            .content-up-txt div span:after {
              width: 70%;
            }
            
            .content-up-txt div span {
              color: #409EFF;
            }
          }
        }

        .course_cover {
          width: 30px;
          height: 30px;
          border-radius: 5px;
        }

        .course_title {
          font-size: 14px;
        }

        .course_time {
          font-size: 10px;
        }
        .courselist {
          padding: 10px;
        }

        .info_wrapper {
          .info_wrapper_1 {
            margin: 20px 10px 20px 10px;
            border: 1px solid rgb(240, 238, 238);
            border-radius: 5px;

            .info_wrapper_class {
              text-align: center;
              padding-top: 10px;
              color: rgb(138, 138, 138);
            }

            .info_wrapper_classnum {
              text-align: center;
              padding-bottom: 10px;
              font-size: 24px;
              font-weight: 500;
              color: 383838;
            }
          }
        }
      }
    }
  }

  .wrapper-down {
    .wrapper-down-content {
      background: white;
      height: calc((100vh - 60px) / 1.5 - 10px);
      margin: 5px;
      border-radius: 5px;

      .title11 {
        color: #323233;
        font-weight: 600;
        padding-left: 20px;
        padding-top: 20px;
        font-size: 16px;
      }

      .title {
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        padding-left: 20px;
      }

      .content-up {
        height: calc((100vh - 60px) / 1.5 - 70px);
        overflow-y: auto;

        .myclass {
          background: white;
          cursor: pointer;
          border: 1px solid #f0eeee;
          margin-top: 10px;
          margin-left: 10px;
          margin-right: 10px;
          border-radius: 12px;
          padding-bottom: 10px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          height: calc(100% - 20px);
          display: flex;
          flex-direction: column;
          
          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
          }

          .class_img {
            width: 100%;
            height: 0;
            padding-bottom: 65%;
            background-repeat: no-repeat;
            background-size: cover;
            border-radius: 12px 12px 0px 0px;
            overflow: hidden;
            position: relative;
            flex-shrink: 0;

            canvas {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .class_room {
            margin-top: 10px;
            padding: 0 10px;
            flex-grow: 1;

            .classname {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-weight: 600;
              color: #323233;
              font-size: 15px;
              padding: 5px 0;
            }
          }

          .class_time {
            padding: 0 10px;
            margin-top: 5px;
            margin-bottom: 5px;
            
            .lesson-count {
              background: #f0f9ff;
              padding: 4px 8px;
              border-radius: 20px;
              font-size: 13px;
              color: #409EFF;
              display: inline-flex;
              align-items: center;
              
              i {
                margin-right: 5px;
                font-size: 14px;
              }
            }
          }
        }

        .myclass_goall {
          height: calc((100vh - 60px) / 2 - 150px);
          margin-top: 20px;
          margin-bottom: 40px;
          flex: 1;
          display: flex;
          flex-flow: column;
          line-height: calc((100vh - 60px) / 2 - 150px);
        }
      }

      .boxStyle {
        padding: 0 20px;
      }
    }

    .contant {
      background: white;
      height: calc((100vh - 60px) / 1.5 - 10px);
      margin: 5px;
      border-radius: 5px;
      flex: 1;
      display: flex;
      flex-flow: column;

      .contant_img {
        width: 100%;
        height: 0;
        padding-bottom: 80%;

        .contant_img_1 {
          width: 80%;
          margin-top: 2%;
          margin-left: 10%;
        }
      }

      .contant_content {
        flex: 1;
        text-align: center;
      }

      .contant_btn {
        flex: 1;
        text-align: center;
      }
    }
  }

  .chatcontent {
    height: 50vh;
    overflow-y: scroll;
  }

  .loading-text {
    font-size: 16px;
    text-align: left;
    line-height: 40px;
    margin-left: 50px;
  }

  .loading-text span {
    animation: loading-text 2s infinite;
  }

  .loading-text span:nth-child(2) {
    animation-delay: 0.4s;
  }

  .loading-text span:nth-child(3) {
    animation-delay: 0.8s;
  }

  @keyframes loading-text {
    0%,
    100% {
      opacity: 0;
    }

    50% {
      opacity: 1;
    }
  }
}

// @media only screen and (max-width: 1200px) {
//   .content-up-imgwrapper {
//     margin-top: 7%;
//   }
// }

// @media screen and (max-width: 1500px) and (min-width: 1200px) {
//   .content-up-imgwrapper {
//     margin-top: 11%;
//   }
// }

// @media screen and (max-width: 1660px) and (min-width: 1500px) {
//   .content-up-imgwrapper {
//     margin-top: 18%;
//   }
// }

// @media screen and (min-width: 1660px) {
//   .content-up-imgwrapper {
//     margin-top: 22%;
//   }
// }

// .content-up-imgwrapper {
//           // margin-top: 40%;
//           padding: 10px;
//           text-align: center;
//           cursor: pointer;

//           .content-up-img {
//             width: 40px;
//             height: 40px;
//             border-radius: 8px;
//             margin: 0 auto;
//             overflow: hidden;
//           }
//         }
/deep/.hljs {
  padding: 20px;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

/deep/ .el-timeline-item__node--normal {
  width: 7.5px;
  height: 7.5px;
}

/deep/ .el-timeline-item__wrapper {
  padding-left: 18px;
}

/deep/ .el-timeline-item__tail {
  left: 4.5px;
}

/deep/ .el-timeline-item__node--normal {
  left: 2px;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.rightBox {
  height: calc((100vh - 60px) / 1.5 - 200px);
  overflow-y: auto;
}

.txtStyle {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

/deep/ .el-timeline-item__timestamp.is-top {
  margin-bottom: 0px;
}

/* 响应式布局调整 */
@media only screen and (max-width: 768px) {
  .class_img1 {
    padding: 0 5px;
  }
  
  .myclass {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  
  .lesson-count {
    font-size: 12px !important;
    padding: 3px 6px !important;
  }
  
  .classname {
    font-size: 14px !important;
  }
}

/* 课程日历卡片样式 */
.calendar-card {
  background: white;
  height: calc((100vh - 60px) / 1.5 - 40px);
  margin: 5px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 20px 20px 20px;
  position: relative;
  overflow: hidden;
}

/* 日历头部样式 */
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.calendar-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #323233;
}

.calendar-icon {
  color: #409EFF;
  font-size: 22px;
  margin-right: 8px;
}

.month-tag {
  margin-left: 8px;
  background-color: #ecf5ff;
  color: #409EFF;
  border: none;
  border-radius: 12px;
  padding: 2px 8px;
}

.calendar-more {
  color: #409EFF; 
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: all 0.3s;
}

.calendar-more:hover {
  transform: translateX(3px);
}

/* 日历导航样式 */
.calendar-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: #f8f9fe;
  border-radius: 12px;
  padding: 12px 8px;
  margin-top: 10px;
}

.nav-arrow {
  width: 32px;
  height: 32px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.2s;
}

.nav-arrow:hover {
  transform: scale(1.1);
  background: #ecf5ff;
}

.nav-arrow i {
  color: #409EFF;
  font-size: 16px;
}

.calendar-days {
  flex: 1;
  padding: 0 10px;
}

.weekday-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.weekday-item {
  width: calc(100% / 7);
  text-align: center;
  color: #909399;
  font-size: 12px;
  font-weight: 500;
}

.date-row {
  display: flex;
  justify-content: space-between;
}

.date-item-wrapper {
  width: calc(100% / 7);
  text-align: center;
  padding: 2px;
}

.date-item {
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  width: 28px;
  height: 28px;
  line-height: 28px;
  border-radius: 50%;
  margin: 0 auto;
  transition: all 0.3s ease;
  color: #323233;
  position: relative;
}

.date-item:hover {
  background: #c1e0ff;
}

.date-active {
  background: #409EFF;
  color: white;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.5);
}

.date-dot {
  position: absolute;
  width: 4px;
  height: 4px;
  background-color: #FF5722;
  border-radius: 50%;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 1px 2px rgba(255, 87, 34, 0.4);
  z-index: 2;
  transition: all 0.3s ease;
  animation: pulse 1.5s infinite;
}

.date-active .date-dot {
  background-color: white;
  animation: none;
  width: 5px;
  height: 5px;
  bottom: 0px;
}

@keyframes pulse {
  0% {
    transform: translateX(-50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translateX(-50%) scale(1.3);
    opacity: 0.7;
  }
  100% {
    transform: translateX(-50%) scale(1);
    opacity: 1;
  }
}


/* 时间线内容样式 */
.calendar-content {
  flex: 1;
  overflow-y: auto;
  padding-right: 5px;
}

.calendar-content::-webkit-scrollbar {
  width: 4px;
}

.calendar-content::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 4px;
}

.empty-image {
  width: 120px;
  height: 120px;
}

.timeline-card {
  border: 1px solid #f0f2f5;
  padding: 12px 14px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  background: #fff;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.timeline-card:hover {
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.1);
  transform: translateY(-2px);
  border-color: rgba(64, 158, 255, 0.2);
}

.timeline-card:hover::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #409EFF;
  border-radius: 4px 0 0 4px;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.timeline-time {
  color: #909399;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.timeline-time i {
  margin-right: 4px;
  font-size: 14px;
  color: #909399;
}

.timeline-action {
  display: flex;
  align-items: center;
}

.action-tag {
  cursor: pointer;
  border: none;
  background: #409EFF;
  color: white;
  border-radius: 12px;
  font-weight: 500;
  padding: 1px 8px;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
}

.action-tag:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
}

.action-tag.signed {
  background: #909399;
  color: white;
}

.timeline-content {
  padding-top: 4px;
}

.timeline-title {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.lesson-title {
  color: #303133;
  font-weight: 500;
  font-size: 14px;
}

.timeline-class {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  background: #f8f9fe;
  border-radius: 12px;
  padding: 2px 8px;
  width: fit-content;
  max-width: 100%;
}

.timeline-class i {
  margin-right: 4px;
  font-size: 12px;
  color: #409EFF;
}

.calendar-footer {
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
}

/* 时间线样式优化 */
/deep/ .el-timeline-item__node--normal {
  width: 6px;
  height: 6px;
  left: 1px;
}

/deep/ .el-timeline-item__wrapper {
  padding-left: 20px;
}

/deep/ .el-timeline-item__tail {
  left: 3px;
  border-left: 1px solid #e6e6e6;
}

/deep/ .el-timeline-item__timestamp.is-top {
  margin-bottom: 0;
  font-size: 0;
  height: 0;
  padding: 0;
}

/deep/ .el-timeline-item {
  padding-bottom: 16px;
}

/deep/ .el-timeline-item:last-child {
  padding-bottom: 0;
}

/deep/ .el-timeline-item__content {
  padding-bottom: 0;
}

@media only screen and (max-width: 1366px) {
  .calendar-content {
    max-height: calc((100vh - 60px) / 1.5 - 200px);
  }
  
  .timeline-card {
    padding: 10px 12px;
  }
  
  .timeline-title, .timeline-class {
    max-width: 90%;
  }
}

/* 弹出框样式 */
.popover-content {
  padding: 5px 0;
}

.popover-title {
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  margin-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 8px;
}

.popover-info {
  font-size: 13px;
}

.popover-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: #606266;
}

.popover-item i {
  color: #409EFF;
  margin-right: 8px;
  font-size: 14px;
}

/deep/ .el-popover {
  padding: 12px;
  min-width: 200px;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

/* 统一的标题样式 */
.section-header,
.section-header-calendar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.section-header {
  padding: 10px 10px 0px 10px;
}

.section-header:after,
.section-header-calendar:after {
  display: none;
}

.section-title {
  display: flex;
  align-items: center;
}

.title-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  box-shadow: none;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.title-icon:before {
  display: none;
}

.title-icon:after {
  display: none;
}

.title-icon i {
  font-size: 16px;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.title-icon i.el-icon-star-on {
  color: #FFAA00;
  text-shadow: 0 1px 2px rgba(255, 170, 0, 0.2);
}

.title-icon i.el-icon-menu {
  color: #409EFF;
  text-shadow: 0 1px 2px rgba(64, 158, 255, 0.2);
}

.title-icon i.el-icon-user {
  color: #4CAF50;
  text-shadow: 0 1px 2px rgba(76, 175, 80, 0.2);
}

.title-icon i.el-icon-date {
  color: #FF5722;
  text-shadow: 0 1px 2px rgba(255, 87, 34, 0.2);
}

.title-icon .class-icon {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.title-icon .function-icon {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.title-icon .calendar-icon {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.section-title:hover .title-icon {
  transform: scale(1.05);
  box-shadow: none;
}

.section-title:hover .title-icon i,
.section-title:hover .title-icon .class-icon,
.section-title:hover .title-icon .function-icon,
.section-title:hover .title-icon .calendar-icon {
  transform: scale(1.1);
}

.title-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

.section-title:hover .title-text {
  color: #409EFF;
}

.month-tag {
  margin-left: 8px;
  background-color: #ecf5ff;
  color: #409EFF;
  border: none;
  border-radius: 12px;
  padding: 2px 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.section-more {
  padding-right: 8px;
  font-weight: 500;
}

.section-more span {
  color: #409EFF;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.section-more span:hover {
  transform: translateX(3px);
  opacity: 0.9;
}

.section-more i {
  margin-left: 4px;
  font-size: 12px;
}

/* 删除旧的样式 */
.calendar-header,
.calendar-more,
.calendar-title,
.function-title,
.title11 {
  display: none;
}

.section-more {
  padding-right: 8px;
  font-weight: 500;
}

.section-more span {
  color: #409EFF;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.section-more span:hover {
  transform: translateX(3px);
  opacity: 0.9;
}

.section-more i {
  margin-left: 4px;
  font-size: 12px;
}
</style>
